export default __webpack_public_path__ + "static/media/img1.c25eaa28.jpg";